import React, { useEffect, useRef, useState } from 'react';
import { verifyEmail } from '../api/auth';

export default function VerifyEmailPage({ token, onComplete }) {
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');
  const called = useRef(false); // React StrictMode の二重呼び出し対策

  useEffect(() => {
    if (called.current) return; // すでに呼び出し済みなら何もしない
    called.current = true;

    if (!token) { setStatus('error'); setMessage('トークンが見つかりません'); return; }
    verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(err => {
        setStatus('error');
        setMessage(err.response?.data?.detail ?? 'メールアドレスの確認に失敗しました');
      });
  }, [token]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #FF6B9D 0%, #9B5FE3 60%, #7048D4 100%)',
      padding: '16px',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 24,
        padding: 'clamp(28px, 8vw, 48px) clamp(20px, 6vw, 40px)',
        width: '100%',
        maxWidth: 380,
        boxShadow: '0 20px 60px rgba(0,0,0,0.18)',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>
          {status === 'loading' ? '⏳' : status === 'success' ? '✅' : '❌'}
        </div>

        {status === 'loading' && (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#333', marginBottom: 8 }}>
              確認中…
            </div>
            <span className="spinner spinner-dark" style={{ width: 24, height: 24, margin: '0 auto' }} />
          </>
        )}

        {status === 'success' && (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#333', marginBottom: 8 }}>
              メールアドレスを確認しました
            </div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
              登録が完了しました。ログインしてください。
            </div>
            <button
              className="btn btn-primary"
              onClick={onComplete}
              style={{ width: '100%', padding: '12px' }}
            >
              ログインページへ
            </button>
          </>
        )}

        {status === 'error' && (
          <>
            <div style={{ fontSize: 15, fontWeight: 700, color: '#e53e3e', marginBottom: 8 }}>
              確認に失敗しました
            </div>
            <div style={{ fontSize: 13, color: '#666', marginBottom: 24 }}>
              {message}
            </div>
            <button
              className="btn btn-primary"
              onClick={onComplete}
              style={{ width: '100%', padding: '12px' }}
            >
              ログインページへ戻る
            </button>
          </>
        )}
      </div>
    </div>
  );
}
